import { Component } from '@angular/core';

//TODO Unsure how we make this a little more dynamic in the sense of admin, supplier and website
//Other than removing the app component however I feel app component is a really nice way
//TO share the basic preferences throughout the application
import { AppComponent } from '../../../../../apps/supplier-portal/src/app/app.component';

@Component({
  selector: 'boma-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss'],
})
export class InvoiceComponent {
  constructor(public app: AppComponent) {}

  print() {
    window.print();
  }
}
